// The consult list endpoint returns display strings like "07.07.2026, 14:32:00"
// (dd.MM.yyyy, HH:mm:ss — UTC wall-clock, no zone marker); shown without seconds.
export const formatUtcTime = (dateStr: string): string => {
  const [datePart, timePart] = dateStr.split(", ");
  return `${datePart} ${timePart?.substring(0, 5) ?? ""}`;
};
